import { useLocation } from "wouter";
import { ArrowRight, Building2, Users } from "lucide-react";
import { EMPRESAS_AO_VIVO } from "@/lib/launch";

/**
 * Capa de entrada do domínio (rota "/"): o usuário escolhe entre os dois
 * produtos ACORDEI! — Empresas (recuperação tributária, site atual em
 * /empresas) e Consumidor (mediação de consumo, site em reconstrução).
 */
const LOGO_URL = "/acordei-logo-v2.png";

export default function Entrada() {
  const [, navigate] = useLocation();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4 py-12"
      style={{ background: "oklch(0.09 0.025 240)" }}
    >
      {/* Marca central */}
      <div className="flex flex-col items-center mb-12 animate-fade-up">
        <div className="relative mb-4">
          <div className="absolute inset-0 bg-cyan-500/20 blur-3xl rounded-full scale-150" />
          <img
            src={LOGO_URL}
            alt="ACORDEI!"
            className="relative w-20 h-20 object-contain"
          />
        </div>
        <h1 className="font-serif text-4xl md:text-5xl font-extrabold text-white tracking-tight">
          ACORDEI<span className="text-cyan-400">!</span>
        </h1>
        <p className="text-white/40 text-sm mt-3">Escolha por onde quer entrar</p>
      </div>

      {/* Os dois produtos */}
      <div className="grid md:grid-cols-2 gap-6 w-full max-w-3xl">
        {/* ACORDEI! Empresas — GATED até lançamento (EMPRESAS_AO_VIVO).
            Enquanto false, cai em /em-construcao (igual Consumidor); quando o
            Arthur mandar lançar (=true), entra no site tributário (/empresas). */}
        <button
          onClick={() => navigate(EMPRESAS_AO_VIVO ? "/empresas" : "/em-construcao")}
          className="btn-press group text-left rounded-2xl border border-cyan-500/30 bg-[oklch(0.12_0.03_250)] p-8 hover:border-cyan-400/60 hover:shadow-[0_0_40px_rgba(6,182,212,0.25)] transition-all animate-fade-up"
        >
          <div className="inline-flex items-center justify-center w-12 h-12 bg-cyan-500/10 rounded-xl mb-5">
            <Building2 className="w-6 h-6 text-cyan-400" />
          </div>
          <div className="mb-1">
            <span className="font-serif text-2xl font-extrabold text-white">
              ACORDEI<span className="text-cyan-400">!</span>
            </span>
          </div>
          <p className="text-[11px] font-semibold tracking-[0.25em] text-white/45 uppercase mb-4">
            Empresas
          </p>
          <p className="text-sm text-white/55 leading-relaxed mb-6">
            Recuperação tributária administrativa: os impostos que sua empresa
            pagou a mais nos últimos 5 anos, de volta pelo e-CAC.
          </p>
          <span className="inline-flex items-center gap-2 text-cyan-300 font-semibold text-sm group-hover:gap-3 transition-all">
            Entrar <ArrowRight className="w-4 h-4" />
          </span>
        </button>

        {/* ACORDEI! Consumidor — em construção até ir pra produção (depois: subdomínio) */}
        <button
          onClick={() => navigate("/em-construcao")}
          className="btn-press group text-left rounded-2xl border border-violet-500/30 bg-[oklch(0.12_0.03_250)] p-8 hover:border-violet-400/60 hover:shadow-[0_0_40px_rgba(167,139,250,0.25)] transition-all animate-fade-up stagger-1"
        >
          <div className="inline-flex items-center justify-center w-12 h-12 bg-violet-500/10 rounded-xl mb-5">
            <Users className="w-6 h-6 text-violet-400" />
          </div>
          <div className="mb-1">
            <span className="font-serif text-2xl font-extrabold text-white">
              ACORDEI<span className="text-violet-400">!</span>
            </span>
          </div>
          <p className="text-[11px] font-semibold tracking-[0.25em] text-white/45 uppercase mb-4">
            Consumidor
          </p>
          <p className="text-sm text-white/55 leading-relaxed mb-6">
            Mediação extrajudicial de conflitos de consumo, 100% digital:
            reclamação, negociação e acordo sem burocracia.
          </p>
          <span className="inline-flex items-center gap-2 text-violet-300 font-semibold text-sm group-hover:gap-3 transition-all">
            Entrar <ArrowRight className="w-4 h-4" />
          </span>
        </button>
      </div>

      <p className="text-[11px] text-white/25 mt-12">
        © {new Date().getFullYear()} ACORDEI! — Todos os direitos reservados.
      </p>
    </div>
  );
}
